import { type DeeplinkElementType } from '@/pages/menuEntries/MenuEntry.type'
import { createStore } from '@/utils/createStore'

import type { PreviewGrabData } from '../types/applicationData.type'

// Params bag forwarded to the mobile preview's `params` field. Each preview
// page has its own shape (PreviewPageParams<T> on the mobile side), but the
// editor builds these from form state and serializes them as a plain bag —
// `Record<string, unknown>` keeps that flexibility without falling back to
// `any`, so e.g. a `DateTimeMs` mistakenly stored as a string surfaces when
// the bag is consumed.
export type PreviewPageData = Record<string, unknown>

export type GettersPreview = ReturnType<typeof mapGettersPreview>

export class PreviewState {
  page: DeeplinkElementType | null = null
  pageData: PreviewPageData | null = null
  resyncPage: DeeplinkElementType | null = null
  resyncPageData: PreviewPageData | null = null
  packedData: PreviewGrabData | null = null
  isOpen = false
  resyncToHome = false
}

export const {
  preview,
  commit: commitPreview,
  useGetter: useGetterPreview,
  useState: useStatePreview,
  mapGetters: mapGettersPreview,
  mapState: mapStatePreview,
  dispatch: dispatchPreview,
} = createStore({
  namespaced: true,
  moduleName: 'preview',
  initState: new PreviewState(),
  mutations: {
    setPreview(state: PreviewState, payload: Partial<PreviewState>) {
      Object.assign(state, payload)
    },
    resetNavigation(state: PreviewState) {
      state.resyncPage = null
      state.resyncPageData = null
      state.resyncToHome = true
    },
    setPackedData(state: PreviewState, packedData: PreviewGrabData) {
      state.packedData = packedData
    },
    setOpen(state: PreviewState, isOpen: boolean) {
      state.isOpen = isOpen
    },
  },
  actions: {
    toggleOpen({ commit, state }) {
      commit('setOpen', !state.isOpen)
    },
    openPreview({ commit }) {
      commit('setOpen', true)
    },
    closePreview({ commit }) {
      commit('setOpen', false)
    },
  },
  getters: {
    isOpen: (state) => state.isOpen,
    page: (state) => state.page,
    pageData: (state) => state.pageData,
    resyncPage: (state) => state.resyncPage,
    resyncPageData: (state) => state.resyncPageData,
    packedData: (state) => state.packedData,
    resyncToHome: (state) => state.resyncToHome,
  },
})
